import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=497b1727&scoped=true"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"
import style0 from "./Providers.vue?vue&type=style&index=0&id=497b1727&prod&lang=scss"
import style1 from "./Providers.vue?vue&type=style&index=1&id=497b1727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b1727",
  null
  
)

export default component.exports